"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
const react_1 = require("react");
function useInterval(callback, delay, config) {
    const savedCallback = (0, react_1.useRef)();
    const intervalId = (0, react_1.useRef)();
    const clear = (0, react_1.useCallback)(() => {
        clearInterval(intervalId.current);
    }, [intervalId]);
    (0, react_1.useEffect)(() => {
        savedCallback.current = callback;
    }, [savedCallback, callback]);
    (0, react_1.useEffect)(() => {
        var _a;
        function tick() {
            var _a;
            (_a = savedCallback.current) === null || _a === void 0 ? void 0 : _a.call(savedCallback);
        }
        if ((_a = config === null || config === void 0 ? void 0 : config.enabled) !== null && _a !== void 0 ? _a : true) {
            intervalId.current = setInterval(tick, delay);
        }
        return () => {
            clear();
        };
    }, [delay, config]);
    return {
        clear,
    };
}
exports.useInterval = useInterval;
